import axios from "axios";
import util from '@/libs/util.js'
import CryptoJS from 'crypto-js';

//hash
function encryptUser(loginUser) {
  let _user = Object.assign({}, loginUser);
  let key = CryptoJS.enc.Utf8.parse("z1ijn$dk89dl#ers");
  let srcs = CryptoJS.enc.Utf8.parse(_user.password);
  let iv  = CryptoJS.enc.Utf8.parse("12abtrefgabcdefg");
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.CBC,padding: CryptoJS.pad.Pkcs7,iv:iv});
  _user.password = encodeURIComponent( encrypted.toString() );
  return _user;
}

export function AccountLogin (data) {
  return axios.post("api/accountLogin/login", util.objToParameter(encryptUser(data)))
}